import { personalize_banner } from 'feature/personalize/store'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { renderFullCameraPane } from 'page/ProfileScreen/FullCameraPane/FullCameraPane'
import { controller } from 'store/controller'
import { store } from 'store/store'

export const FullPhoto = observer(() => {
  const onBack = useLatestCallback(() => {
    personalize_banner.close()
  })

  const onDone = useLatestCallback(async () => {
    const { userPhoto } = store.profile.common
    const photo = await userPhoto.getUrlPromise()
    if (!photo) return

    await controller.saveProfile()
    personalize_banner.close()
  })

  return renderFullCameraPane(onBack, onDone)
})
